import React from 'react';

import Input from './input';

const Radio = props => {
  const className = `radio ${props.className}`;
  const inputProps = {
    className: props.className,
    value: props.value,
    onClick: props.onClick,
    name: props.name,
    id: `${props.name}_${props.value}`,
    checked: props.checked,
    'data-form': props['data-form'],
    'data-page': props['data-page']
  };

  const highlightText = (text, hightlightText) => {
    const regex = new RegExp(hightlightText, 'gi');
    const replacedTerm = text.replace(regex, `<b>${hightlightText.toLowerCase()}</b>`);
    return { __html: replacedTerm };
  };

  return (
    <div className={className}>
      <Input type="radio" {...inputProps} />
      <label htmlFor={inputProps.id} className="aemp-radio">
        <span
          className="radio-text"
          dangerouslySetInnerHTML={highlightText(props.text, props.filterValue)}
        />
        {!!props.description && (
          <span dangerouslySetInnerHTML={highlightText(props.description, props.filterValue)} />
        )}
      </label>
    </div>
  );
};

export default Radio;
